import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import ReactFileUpload from "../documents/ReactFileUpload";
import { DocumentList } from "../documents/DocumentList";
import { useState,useEffect } from "react";
import { AppraisalAttachment } from "../../../all_Interfaces";
import { useDispatch } from "react-redux";
import { addNewAttachments } from "../../../redux/slices/AddNewAttachmentsSlice";
import { useAppSelector } from "../../../redux/hooks";

export const ViewTabList = (props: any) => {
  // const [tabValue, setValue] = useState("0");
  const dispatch = useDispatch();
  const pathnames = window.location.pathname;
  const [tabValue, setValue] = useState(props.tabData && props.tabData.length > 0 ? "All" : "All");
  const [newAttachments,setNewAttachments] = useState<AppraisalAttachment[]>([]);

  // useEffect(()=> {
  //   setValue("0");
  // },[]);
  const path = window.location.pathname;

  const newAddedAttachments:AppraisalAttachment[] = useAppSelector(state => state.AddNewAttachments.data);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };


  useEffect(() => {
    if (newAttachments.length != 0) {
      dispatch(addNewAttachments([...newAttachments]));
    }
    if (newAddedAttachments.length != 0) {
      dispatch(addNewAttachments([...newAddedAttachments]));
    }
    if (newAttachments.length != 0 && newAddedAttachments.length != 0) {
      dispatch(addNewAttachments([...newAttachments, ...newAddedAttachments]));
    }
    
  }, [newAttachments]);


  
  const getDisplayName = (name: string) => {
    if (name === "CASA Valuation Proforma") return "Excel Valuation Proforma";
    return name;
  };

  return (
    <TabContext value={tabValue}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <TabList
          onChange={handleChange}
          aria-label="document Tab"
          variant="scrollable"
          scrollButtons="auto"
          className="tab-list-wrap"
        >
          <Tab label="All" value="All" key="All"  sx={{textTransform:'capitalize'}}/>
          {props.tabData?.map((item: any, index: any) => (
            <Tab label={getDisplayName(item.name)} value={item.name} key={index} sx={{textTransform:'capitalize'}} />
          ))}
        </TabList>
      </Box>
      <TabPanel value="All" key="All" sx={{ padding: 2 }}>
          <div>
            <DocumentList docType={"All"}/>
          </div>
        </TabPanel>
      {props.tabData?.map((item: any, index: any) => (
        <TabPanel value={item.name} key={index} sx={{ padding: 2 }}>
          <div>
            { (pathnames.includes("edit") || pathnames.includes("new")) && <ReactFileUpload setNewAttachments={setNewAttachments} appraisalType={props.appraisalType} docType={item.name} attachmentTag={item.tag}/>}
            {/* { pathnames.includes("new")  && <ReactFileUpload setNewAttachments={setNewAttachments} appraisalType={props.appraisalType} docType={item.name} attachmentTag={item.tag}/>} */}
            <DocumentList docType={item.name}/>
          </div>
        </TabPanel>
      ))}
    </TabContext>
  );
};
